import React from "react";
import style from "./style.module.css";
import CountdownView from "../../other-components/CountdownView/View";

function Modal({ title, description, data, spaceAbove }) {
    const value = data[0]?.item_description;
    const isUnix = /^\d{10}$/.test(value) || /^\d{13}$/.test(value);

    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            <div className={style.childView}>
                {title ?
                    <div className={style.headerView}>
                        <h2>{title}</h2>
                        <p dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                    : null
                }

                <div className={style.contentsView}>
                    {isUnix ?
                        <CountdownView data={Number(value)} />
                        : null
                    }
                </div>
            </div>
        </div>
    );
}

export default Modal;


